import { intl } from '@fullstory/intl';
import { useEffect } from 'react';

const defaultTitle = 'Fullstory';

type Domain =
  | 'Library'
  | 'Alerts'
  | 'Dashboards'
  | 'DataTables'
  | 'Conversions'
  | 'Home'
  | 'Settings'
  | 'Exports'
  | 'Segments'
  | 'Metrics'
  | 'Journeys'
  | 'Retention'
  | 'Heatmaps'
  | 'Notes'
  | 'Funnels'
  | 'Watch'
  | 'Detections'
  | 'Spaces'
  | 'Annotations'
  | 'Opportunities';

const intlDomains: { [D in Domain]: string } = {
  Library: intl.formatMessage({ defaultMessage: 'Library', id: 'StcK67' }),
  Alerts: intl.formatMessage({ defaultMessage: 'Alerts', id: '9zub+u' }),
  Dashboards: intl.formatMessage({ defaultMessage: 'Dashboards', id: 'nwqt7T' }),
  DataTables: intl.formatMessage({ defaultMessage: 'Tables', id: 'b7YdZ/' }),
  Conversions: intl.formatMessage({ defaultMessage: 'Conversions', id: 'WuHoZ9' }),
  Home: intl.formatMessage({ defaultMessage: 'Home', id: 'ejEGdx' }),
  Settings: intl.formatMessage({ defaultMessage: 'Settings', id: 'D3idYv' }),
  Exports: intl.formatMessage({ defaultMessage: 'Exports', id: 'd+FzF5' }),
  Segments: intl.formatMessage({ defaultMessage: 'Segments', id: 'VF3DcR' }),
  Metrics: intl.formatMessage({ defaultMessage: 'Metrics', id: 'HNBpJ4' }),
  Journeys: intl.formatMessage({ defaultMessage: 'Journeys', id: '08hqOd' }),
  Retention: intl.formatMessage({ defaultMessage: 'Retention', id: 'nL6Jl0' }),
  Heatmaps: intl.formatMessage({ defaultMessage: 'Heatmaps', id: 'geWuHd' }),
  Notes: intl.formatMessage({ defaultMessage: 'Notes', id: '7+Domh' }),
  Funnels: intl.formatMessage({ defaultMessage: 'Funnels', id: 'puhcpn' }),
  Watch: intl.formatMessage({ defaultMessage: 'Watch', id: 'aaiLWk' }),
  Detections: intl.formatMessage({ defaultMessage: 'Detections', id: 'PDn6wF' }),
  Spaces: intl.formatMessage({ defaultMessage: 'Spaces', id: 'ZMoczs' }),
  Annotations: intl.formatMessage({ defaultMessage: 'Annotations', id: 'c2l+EP' }),
  Opportunities: intl.formatMessage({ defaultMessage: 'Opportunities', id: 'zB5VYc' }),
};

export function useDocumentTitle(domain: Domain, title?: string | null) {
  useEffect(() => {
    let documentTitle: string = intlDomains[domain];
    if (title) documentTitle = `${documentTitle} | ${title}`;
    document.title = `${documentTitle} | ${defaultTitle}`;
  }, [domain, title]);

  // reset the title to default on unmount
  useEffect(
    () => () => {
      document.title = defaultTitle;
    },
    [],
  );
}
